// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1n7w2","location":"Header_location__u6u3d"};